import { useIntl } from 'react-intl';

export function useQuestionnaireCopy() {
  const intl = useIntl();

  const styleText = {
    b: (str) => <b>{str}</b>,
    br: (_) => <br />,
  };

  const defaultQuestions = [
    {
      linkId: 'PI',
      text: intl.formatMessage({
        id: 'questionnaire.pi',
        defaultMessage: 'In the past 7 days...',
      }),
      type: 'group',
      item: [
        {
          linkId: 'PI_0',
          text: intl.formatMessage({
            id: 'questionnaire.pi.0',
            defaultMessage: 'how bad was your pain on average?',
          }),
          type: 'integer',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'NO_SCORE' }],
        },
        {
          linkId: 'PI_1',
          text: intl.formatMessage({
            id: 'questionnaire.pi.1',
            defaultMessage: 'I had trouble sleeping when I had pain',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: {
            reference: 'ValueSet/fiveOptionsNeverAlways',
          },
        },
        {
          linkId: 'PI_2',
          text: intl.formatMessage({
            id: 'questionnaire.pi.2',
            defaultMessage: 'it was hard for me to pay attention when I had pain',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNeverAlways' },
        },
        {
          linkId: 'PI_3',
          text: intl.formatMessage({
            id: 'questionnaire.pi.3',
            defaultMessage: 'it was hard for me to run when I had pain',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNeverAlways' },
        },
        {
          linkId: 'PI_4',
          text: intl.formatMessage({
            id: 'questionnaire.pi.4',
            defaultMessage: 'it was hard for me to walk one block when I had pain',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNeverAlways' },
        },
      ],
    },
    {
      linkId: 'AQ',
      text: intl.formatMessage({
        id: 'questionnaire.aq',
        defaultMessage: 'In the past 7 days...',
      }),
      type: 'group',
      item: [
        {
          linkId: 'AQ_0',
          text: intl.formatMessage(
            {
              id: 'questionnaire.aq.0',
              defaultMessage:
                '<b>Why are we asking about worry?</b><br></br><br></br>Any level of worry (like feeling anxious or nervous) can impact the level of pain you feel in your body. And pain can lead to more worries. Worrying involves many physical sensations and anxious thoughts, which in turn can amplify your pain. Your pain can also increase your worry.',
            },
            styleText,
          ),
          type: 'display',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'DISPLAY' }],
        },
        {
          linkId: 'AQ_1',
          text: intl.formatMessage({
            id: 'questionnaire.aq.1',
            defaultMessage: 'I felt like something awful might happen',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNeverAlways' },
        },
        {
          linkId: 'AQ_2',
          text: intl.formatMessage({
            id: 'questionnaire.aq.2',
            defaultMessage: 'I felt nervous',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNeverAlways' },
        },
        {
          linkId: 'AQ_3',
          text: intl.formatMessage({
            id: 'questionnaire.aq.3',
            defaultMessage: 'I felt worried',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNeverAlways' },
        },
        {
          linkId: 'AQ_4',
          text: intl.formatMessage({
            id: 'questionnaire.aq.4',
            defaultMessage: 'I worried when I was at home',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNeverAlways' },
        },
      ],
    },
    {
      linkId: 'DS',
      text: intl.formatMessage({
        id: 'questionnaire.ds',
        defaultMessage: 'In the past 7 days...',
      }),
      type: 'group',
      item: [
        {
          linkId: 'DS_0',
          text: intl.formatMessage(
            {
              id: 'questionnaire.ds.0',
              defaultMessage:
                '<b>Why are we asking about mood?</b><br></br><br></br>Pain can lead to feeling down, low, and sad. This impacts your level of pain because negative moods and pain are processed in some of the same areas of the brain.',
            },
            styleText,
          ),
          type: 'display',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'DISPLAY' }],
        },
        {
          linkId: 'DS_1',
          text: intl.formatMessage({
            id: 'questionnaire.ds.1',
            defaultMessage: 'I felt everything in my life went wrong',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNeverAlways' },
        },
        {
          linkId: 'DS_2',
          text: intl.formatMessage({
            id: 'questionnaire.ds.2',
            defaultMessage: 'I felt lonely',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNeverAlways' },
        },
        {
          linkId: 'DS_3',
          text: intl.formatMessage({
            id: 'questionnaire.ds.3',
            defaultMessage: 'I felt sad',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNeverAlways' },
        },
        {
          linkId: 'DS_4',
          text: intl.formatMessage({
            id: 'questionnaire.ds.4',
            defaultMessage: 'it was hard for me to have fun',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNeverAlways' },
        },
      ],
    },
    {
      linkId: 'SQ',
      text: intl.formatMessage(
        {
          id: 'questionnaire.sq',
          defaultMessage:
            'Please rate the <b>severity</b> of your insomnia over the last two weeks.',
        },
        styleText,
      ),
      type: 'group',
      item: [
        {
          linkId: 'SQ_0',
          text: intl.formatMessage(
            {
              id: 'questionnaire.sq.0',
              defaultMessage:
                '<b>Why are we asking about sleep?</b><br></br><br></br>Pain can impact both how long you stay asleep and the quality of your sleep. Sleep is an important function which gives your body a chance to perform maintenance and recover from a tough day. Without good quality sleep, you may notice an increase in your pain and a decrease in your ability to cope with your pain.',
            },
            styleText,
          ),
          type: 'display',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'DISPLAY' }],
        },
        {
          linkId: 'SQ_1',
          text: intl.formatMessage({
            id: 'questionnaire.sq.1',
            defaultMessage: 'Difficulty falling asleep',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNoneVerySevere' },
        },
        {
          linkId: 'SQ_2',
          text: intl.formatMessage({
            id: 'questionnaire.sq.2',
            defaultMessage: 'Difficulty staying asleep',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNoneVerySevere' },
        },
        {
          linkId: 'SQ_3',
          text: intl.formatMessage({
            id: 'questionnaire.sq.3',
            defaultMessage: 'Problems waking up too early',
          }),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNoneVerySevere' },
        },
        {
          linkId: 'SQ_4',
          text: intl.formatMessage(
            {
              id: 'questionnaire.sq.4',
              defaultMessage:
                'How <b>satisfied/dissatisfied</b> are you with your <b>current</b> sleep pattern?',
            },
            styleText,
          ),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsSatisfiedDissatisfied' },
        },
        {
          linkId: 'SQ_5',
          text: intl.formatMessage(
            {
              id: 'questionnaire.sq.5',
              defaultMessage:
                'How <b>noticeable</b> to others do you think your sleep problems are in terms of impairing the quality of your life?',
            },
            styleText,
          ),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNotAtAllVeryMuchNoticeable' },
        },
        {
          linkId: 'SQ_6',
          text: intl.formatMessage(
            {
              id: 'questionnaire.sq.6',
              defaultMessage:
                'How <b>worried/distressed</b> are you about your current sleep problem?',
            },
            styleText,
          ),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNotAtAllVeryMuchWorried' },
        },
        {
          linkId: 'SQ_7',
          text: intl.formatMessage(
            {
              id: 'questionnaire.sq.7',
              defaultMessage:
                'To what extent do you consider your sleeping problem to <b>interfere</b> with your daily functioning (e.g. daytime fatigue, mood, ability to function at work/daily chores, concentration, memory, etc.) <b>currently</b>?',
            },
            styleText,
          ),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNotAtAllVeryMuchInterfering' },
        },
      ],
    },
    {
      linkId: 'CQ',
      text: intl.formatMessage(
        {
          id: 'questionnaire.cq',
          defaultMessage: 'During the past <b>2 weeks</b>, on how many days did you:',
        },
        styleText,
      ),
      type: 'group',
      item: [
        {
          linkId: 'CQ_0',
          text: intl.formatMessage(
            {
              id: 'questionnaire.cq.0',
              defaultMessage:
                '<b>Why are we asking about substance use?</b><br></br><br></br>Some teens turn to substances to try and cope with their chronic pain. Unfortunately, any level of substance use can have negative impacts on chronic pain and related symptoms. Assess today to learn about substance use, and how this may be impacting your pain and function.',
            },
            styleText,
          ),
          type: 'display',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'DISPLAY' }],
        },
        {
          linkId: 'CQ_1',
          text: intl.formatMessage({
            id: 'questionnaire.cq.1',
            defaultMessage:
              'Please note that you may skip this questionnaire if you feel uncomfortable answering any questions. However, if you skip the questionnaire, you will not receive a substance use score or any recommendations for this category.',
          }),
          type: 'display',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SKIP' }],
        },
        {
          linkId: 'CQ_2',
          text: intl.formatMessage(
            {
              id: 'questionnaire.cq.2',
              defaultMessage:
                "Drink more than a few sips of beer, wine, or any drink containing <b>alcohol</b>? Put '0' if none.",
            },
            styleText,
          ),
          type: 'decimal',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
        },
        {
          linkId: 'CQ_3',
          text: intl.formatMessage(
            {
              id: 'questionnaire.cq.3',
              defaultMessage:
                "Use any <b>marijuana</b> (weed, oil, wax, or hash by smoking, vaping, dabbing, or in food) or ''<b>synthetic marijuana</b>'' (like 'K2', 'Spice')? Put '0' if none.",
            },
            styleText,
          ),
          type: 'decimal',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
        },
        {
          linkId: 'CQ_4',
          text: intl.formatMessage(
            {
              id: 'questionnaire.cq.4',
              defaultMessage:
                "Use <b>anything else to get high</b> (like other illegal drugs, prescription or over-the-counter medications, and things that you sniff, huff, vape, or inject)? Put '0' if none.",
            },
            styleText,
          ),
          type: 'decimal',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
        },
        {
          linkId: 'CQ_5',
          text: intl.formatMessage(
            {
              id: 'questionnaire.cq.5',
              defaultMessage:
                "Use a <b>vaping device*</b> containing nicotine and/or flavors, or use any tobacco products†? Put '0' if none.<br></br><br></br>*Such as e-cigs, mods, pod devices like JUUL, disposable vapes like Puff Bar, vape pens, or e-hookahs. †Cigarettes, cigars, cigarillos, hookahs, chewing tobacco, snuff, snus, dissolvables, or nicotine pouches.",
            },
            styleText,
          ),
          type: 'decimal',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
        },
      ],
    },
  ];

  const bscq = [
    {
      linkId: 'BSCQ',
      text: intl.formatMessage({
        id: 'questionnaire.bscq',
        defaultMessage:
          'Right now, how confident are you that you can resist drinking or using another drug when you feel',
      }),
      type: 'group',
      code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'NO_SCORE' }],
      item: [
        {
          linkId: 'BSCQ_0',
          text: intl.formatMessage(
            {
              id: 'questionnaire.bscq.0',
              defaultMessage: '<b>unpleasant emotions?</b>',
            },
            styleText,
          ),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNotAtAllTotallyConfident' },
        },
        {
          linkId: 'BSCQ_1',
          text: intl.formatMessage(
            {
              id: 'questionnaire.bscq.1',
              defaultMessage: '<b>physical discomfort?</b>',
            },
            styleText,
          ),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNotAtAllTotallyConfident' },
        },
        {
          linkId: 'BSCQ_2',
          text: intl.formatMessage(
            {
              id: 'questionnaire.bscq.2',
              defaultMessage: '<b>pleasant emotions?</b>',
            },
            styleText,
          ),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNotAtAllTotallyConfident' },
        },
        {
          linkId: 'BSCQ_3',
          text: intl.formatMessage(
            {
              id: 'questionnaire.bscq.3',
              defaultMessage:
                'like <b>testing control over your use of alcohol or another drug?</b>',
            },
            styleText,
          ),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNotAtAllTotallyConfident' },
        },
        {
          linkId: 'BSCQ_4',
          text: intl.formatMessage(
            {
              id: 'questionnaire.bscq.4',
              defaultMessage: '<b>urges and temptations?</b>',
            },
            styleText,
          ),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNotAtAllTotallyConfident' },
        },
        {
          linkId: 'BSCQ_5',
          text: intl.formatMessage(
            {
              id: 'questionnaire.bscq.5',
              defaultMessage: 'you have <b>conflict with others?</b>',
            },
            styleText,
          ),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNotAtAllTotallyConfident' },
        },
        {
          linkId: 'BSCQ_6',
          text: intl.formatMessage(
            {
              id: 'questionnaire.bscq.6',
              defaultMessage: 'you have <b>social pressure to drink/use drugs?</b>',
            },
            styleText,
          ),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNotAtAllTotallyConfident' },
        },
        {
          linkId: 'BSCQ_7',
          text: intl.formatMessage(
            {
              id: 'questionnaire.bscq.7',
              defaultMessage: 'you have <b>pleasant times with others?</b>',
            },
            styleText,
          ),
          type: 'choice',
          code: [{ system: 'ValueSet/checkInQuestionCodes', code: 'SCORE' }],
          options: { reference: 'ValueSet/fiveOptionsNotAtAllTotallyConfident' },
        },
      ],
    },
  ];

  const optionsMap = {
    'ValueSet/fiveOptionsNeverAlways': [
      {
        label: intl.formatMessage({
          id: 'valueset.fiveOptionsNeverAlways.never',
          defaultMessage: 'Never',
        }),
        value: 1,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveOptionsNeverAlways.almost-never',
          defaultMessage: 'Almost Never',
        }),
        value: 2,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveOptionsNeverAlways.sometimes',
          defaultMessage: 'Sometimes',
        }),
        value: 3,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveOptionsNeverAlways.often',
          defaultMessage: 'Often',
        }),
        value: 4,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveOptionsNeverAlways.almost-always',
          defaultMessage: 'Almost Always',
        }),
        value: 5,
      },
    ],
    'ValueSet/fiveOptionsNoneVerySevere': [
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnoneverysevere.none',
          defaultMessage: 'None',
        }),
        value: 1,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnoneverysevere.mild',
          defaultMessage: 'Mild',
        }),
        value: 2,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnoneverysevere.moderate',
          defaultMessage: 'Moderate',
        }),
        value: 3,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnoneverysevere.severe',
          defaultMessage: 'Severe',
        }),
        value: 4,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnoneverysevere.very-severe',
          defaultMessage: 'Very Severe',
        }),
        value: 5,
      },
    ],
    'ValueSet/fiveOptionsSatisfiedDissatisfied': [
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionssatisfieddissatisfied.very-satisfied',
          defaultMessage: 'Very Satisfied',
        }),
        value: 1,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionssatisfieddissatisfied.satisfied',
          defaultMessage: 'Satisfied',
        }),
        value: 2,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionssatisfieddissatisfied.moderately-satisfied',
          defaultMessage: 'Moderately Satisfied',
        }),
        value: 3,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionssatisfieddissatisfied.dissatisfied',
          defaultMessage: 'Dissatisfied',
        }),
        value: 4,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionssatisfieddissatisfied.very-dissatisfied',
          defaultMessage: 'Very Dissatisfied',
        }),
        value: 5,
      },
    ],
    'ValueSet/fiveOptionsNotAtAllVeryMuchNoticeable': [
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchnoticeable.not-at-all-noticeable',
          defaultMessage: 'Not At All Noticeable',
        }),
        value: 1,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchnoticeable.a-little',
          defaultMessage: 'A Little',
        }),
        value: 2,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchnoticeable.somewhat-noticeable',
          defaultMessage: 'Somewhat Noticeable',
        }),
        value: 3,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchnoticeable.much',
          defaultMessage: 'Much',
        }),
        value: 4,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchnoticeable.very-much-noticeable',
          defaultMessage: 'Very Much Noticeable',
        }),
        value: 5,
      },
    ],
    'ValueSet/fiveOptionsNotAtAllVeryMuchWorried': [
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchworried.not-at-all-worried',
          defaultMessage: 'Not At All Worried',
        }),
        value: 1,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchworried.a-little',
          defaultMessage: 'A Little',
        }),
        value: 2,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchworried.somewhat-worried',
          defaultMessage: 'Somewhat Worried',
        }),
        value: 3,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchworried.much',
          defaultMessage: 'Much',
        }),
        value: 4,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchworried.very-much-worried',
          defaultMessage: 'Very Much Worried',
        }),
        value: 5,
      },
    ],
    'ValueSet/fiveOptionsNotAtAllVeryMuchInterfering': [
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchinterfering.not-at-all-interfering',
          defaultMessage: 'Not At All Interfering',
        }),
        value: 1,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchinterfering.a-little',
          defaultMessage: 'A Little',
        }),
        value: 2,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchinterfering.somewhat-interfering',
          defaultMessage: 'Somewhat Interfering',
        }),
        value: 3,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchinterfering.much',
          defaultMessage: 'Much',
        }),
        value: 4,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatallverymuchinterfering.very-much-interfering',
          defaultMessage: 'Very Much Interfering',
        }),
        value: 5,
      },
    ],
    'ValueSet/fiveOptionsNotAtAllTotallyConfident': [
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatalltotallyconfident.not-at-all-confident',
          defaultMessage: 'Not At All Confident',
        }),
        value: 0,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatalltotallyconfident.slightly-confident',
          defaultMessage: 'Slightly Confident',
        }),
        value: 25,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatalltotallyconfident.unsure',
          defaultMessage: 'Unsure',
        }),
        value: 50,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatalltotallyconfident.fairly-confident',
          defaultMessage: 'Fairly Confident',
        }),
        value: 75,
      },
      {
        label: intl.formatMessage({
          id: 'valueset.fiveoptionsnotatalltotallyconfident.totally-confident',
          defaultMessage: 'Totally Confident',
        }),
        value: 100,
      },
    ],
  };
  const getOptions = (options) => optionsMap[options?.reference] ?? [];

  return { defaultQuestions, bscq, getOptions };
}

export const flattenQuestionnaire = (questions, cardsToHide) =>
  questions.flatMap((item) => {
    const to_itself_with_group_text_and_LinkId = (innerItem) => ({
      ...innerItem,
      groupLinkId: item.linkId,
      groupText: item.text,
    });
    return (
      item.type.toLowerCase() === 'group' ? item.item.map(to_itself_with_group_text_and_LinkId) : []
    ).filter((item) => cardsToHide?.includes(item.linkId) === false);
  });
